export const ACADEMY_SUPPORTED_LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];
function toLowerCaseTuple(arr) {
  return arr.map(language => language.toLowerCase());
}
export const supportedPublicLanguages = toLowerCaseTuple(ACADEMY_SUPPORTED_LANGUAGES);